import { render, staticRenderFns } from "./UserSection.vue?vue&type=template&id=45f125b8&scoped=true"
import script from "./UserSection.vue?vue&type=script&lang=js"
export * from "./UserSection.vue?vue&type=script&lang=js"
import style0 from "./UserSection.vue?vue&type=style&index=0&id=45f125b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f125b8",
  null
  
)

export default component.exports